// Client-side mirror of backend commission logic (used for live preview).
export const VAT_RATE = 0.20;
export const BANK_COMMISSION_RATE = 0.03;

export const SERVICE_RATES = {
  hand: 0.70,
  foot: 0.30,
  eyebrow: 0.50,
  product: 1.00,
};

export const SERVICE_LABELS = {
  hand: 'El',
  foot: 'Ayak',
  eyebrow: 'Kaş',
  product: 'Direk Satış/Ürün',
};

export const PAYMENT_LABELS = {
  cash: 'Nakit',
  credit_card: 'Kredi Kartı',
};

const round2 = (n) => Math.round((n + Number.EPSILON) * 100) / 100;

export function calculateCommission(amount, serviceType, paymentMethod) {
  const gross = Number(amount) || 0;
  const staffRate = SERVICE_RATES[serviceType] ?? 0.3;
  const centerRate = 1 - staffRate;

  let vatExcluded, vat, bank, net;
  if (paymentMethod === 'credit_card') {
    vatExcluded = gross / (1 + VAT_RATE);
    vat = gross - vatExcluded;
    bank = gross * BANK_COMMISSION_RATE;
    net = vatExcluded - bank;
  } else {
    vatExcluded = gross;
    vat = 0;
    bank = 0;
    net = gross;
  }

  return {
    gross: round2(gross),
    vat_excluded: round2(vatExcluded),
    vat: round2(vat),
    bank_commission: round2(bank),
    net: round2(net),
    staff_share: round2(net * staffRate),
    center_share: round2(net * centerRate),
    staff_rate: staffRate,
    center_rate: centerRate,
  };
}

export const formatTRY = (n) => {
  const num = new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(n) || 0);
  return `${num} TL`;
};

export const formatDate = (isoDate) => {
  if (!isoDate) return '';
  const [y, m, d] = isoDate.split('-');
  return `${d}.${m}.${y}`;
};

export const todayISO = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

export const shiftDate = (isoDate, days) => {
  const [y, m, d] = isoDate.split('-').map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  dt.setUTCDate(dt.getUTCDate() + days);
  const yy = dt.getUTCFullYear();
  const mm = String(dt.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(dt.getUTCDate()).padStart(2, '0');
  return `${yy}-${mm}-${dd}`;
};
